import React, { FC, HTMLAttributes } from "react";
import styled from "styled-components";

export const EnclosureSp: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <Root {...props}>
      <FrameTop>
        <TopLine />
        <TopDiagonalLine />
        <RightLine />
      </FrameTop>
      <FrameBottom>
        <LeftLine />
        <BottomDiagonalLine />
        <BottomLine />
      </FrameBottom>
      {children}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  width: 100%;
  padding: 40px 10px;
  color: #FFF;
  font-size: 10px;
`;
const FrameTop = styled.div`
  position: absolute;
  top: 0;
  width: calc(100% - 20px);
  height: 40px;
`;
const TopLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 1px;
  width: calc(100% - 16px);
  background-color: #FFF;
`;
const RightLine = styled.div`
  position: absolute;
  top: 14px;
  right: 2px;
  height: 20px;
  width: 1px;
  background-color: #FFF;
`;
const TopDiagonalLine = styled.div`
  position: absolute;
  top: 0;
  right: 16px;
  height: 20px;
  width: 1px;
  transform: rotate(-45deg);
  transform-origin: top left;
  background-color: #FFF;
`;
const FrameBottom = styled.div`
  position: absolute;
  bottom: 0;
  width: calc(100% - 20px);
  height: 64px;
`;
const LeftLine = styled.div`
  position: absolute;
  bottom: 14px;
  left: 2px;
  height: 40px;
  width: 1px;
  background-color: #FFF;
`;
const BottomLine = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  height: 1px;
  width: calc(100% - 16px);
  background-color: #FFF;
`;
const BottomDiagonalLine = styled.div`
  position: absolute;
  bottom: 0;
  left: calc(16px - 20px);
  height: 1px;
  width: 20px;
  transform: rotate(45deg);
  transform-origin: bottom right;
  background-color: #FFF;
`;
